var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDestinationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4607_46700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9898 6.93729C13.9898 11.5643 8.0408 15.5303 8.0408 15.5303C8.0408 15.5303 2.0918 11.5643 2.0918 6.93729C2.0918 5.35951 2.71857 3.84636 3.83422 2.7307C4.94988 1.61505 6.46303 0.988281 8.0408 0.988281C9.61858 0.988281 11.1317 1.61505 12.2474 2.7307C13.363 3.84636 13.9898 5.35951 13.9898 6.93729Z",
    stroke: "#353E5A",
    strokeWidth: 1.1898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0416 8.91913C9.13678 8.91913 10.0246 8.03131 10.0246 6.93613C10.0246 5.84095 9.13678 4.95312 8.0416 4.95312C6.94641 4.95312 6.05859 5.84095 6.05859 6.93613C6.05859 8.03131 6.94641 8.91913 8.0416 8.91913Z",
    stroke: "#353E5A",
    strokeWidth: 1.1898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4607_46700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.864,
    height: 15.864,
    fill: "white",
    transform: "translate(0.109375 0.326172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationPin);
export default __webpack_public_path__ + "static/media/destination_pin.36809e594a4024277a9a5d1917297203.svg";
export { ForwardRef as ReactComponent };